import PhoneInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import { cn } from '@/lib/utils';
import { CountrySelect } from './CountrySelect';

export function PhoneInputField({
  id,
  value,
  onChange,
  onBlur,
  error = false,
  disabled = false,
  placeholder = 'Phone number',
  ...props
}) {
  return (
    <div
      className={cn(
        'phone-input-field flex h-11 w-full rounded-md border-2 bg-white transition',
        error
          ? 'border-rose-400 focus-within:border-rose-500 focus-within:ring-2 focus-within:ring-rose-400/30'
          : 'border-slate-300 focus-within:border-brand-500 focus-within:ring-2 focus-within:ring-brand-500/20',
        disabled && 'opacity-60'
      )}
    >
      <PhoneInput
        id={id}
        international
        defaultCountry="US"
        value={value || ''}
        onChange={(v) => onChange(v || '')}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        flags={flags}
        countrySelectComponent={CountrySelect}
        {...props}
      />
    </div>
  );
}